/*export const enum RoleLevel {
    Guest = 0,
    Signatory = 100, 
    SignatureRequestor = 500, 
    Administrator = 1000,
    PaisleyAdministrator = 10000
}*/
export const enum RoleLevel {
    Guest,
    Signatory, 
    SignatureRequestor, 
    Administrator,
    PaisleyAdministrator
}
export type Role = {
    id?: string;
    name: string;
    description: string;
    level: RoleLevel;
}
export default Role;